// ** Icons Import
import { Heart } from "react-feather"
import themeConfig from '@configs/themeConfig'

const Footer = () => {
  return (
    <p className="clearfix mb-0">
      <span className="float-md-end d-block d-md-inline-block mt-25">
        COPYRIGHT © {new Date().getFullYear()}{" "}
        <a
          href="https://dashboard.smarterdealer.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#fff' }}
        >
          {themeConfig.app.appName}
        </a>
        {/* <Heart className="ficon" fill="red"></Heart> */}
        <span className="d-none d-sm-inline-block">, All Rights Reserved</span>
      </span>
    </p>
  )
}

export default Footer;
